module.exports = __webpack_public_path__ + "media/img/home/directions/direction3-1afcf37e451d05228a39f2e85a28e7d6.svg";